// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-accordion-title {
  cursor: pointer;
}
.custom-accordion-title svg {
  flex-shrink: 0;
}

.custom-accordion-wrapper {
  background-color: #FDFDFD;
}
.custom-accordion-wrapper .accordion-title {
  cursor: pointer;
}
.custom-accordion-wrapper .accordion-title svg {
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/price-breakup/style.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,cAAA;AACJ;;AAGA;EACE,yBAAA;AAAF;AAEE;EACE,eAAA;AAAJ;AAEI;EACE,cAAA;AAAN","sourcesContent":[".custom-accordion-title {\n  cursor: pointer;\n\n  svg {\n    flex-shrink: 0;\n  }\n}\n\n.custom-accordion-wrapper {\n  background-color: theme('colors.white');\n\n  .accordion-title {\n    cursor: pointer;\n\n    svg {\n      flex-shrink: 0;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
